<div class="frame">
  <div class="title-wrapper">
    <span class="title">RESUMO DO FINANCIAMENTO</span>
  </div>

  <div class="info-wrapper">
    <div class="info-block">
      <span class="icon money-bill"></span>
      <div class="info">
        <span class="text">Valor Solicitado</span>
        <span class="value">
          {{ proposta.valorLiquido | currency: 'BRL' }}</span
        >
      </div>
    </div>
    <div class="info-block">
      <span class="icon calendario-cash"></span>
      <div class="info">
      <span class="text">Parcelas</span>
        <span class="value"
          >{{ proposta.qtdeParcelas }}x
          {{ proposta.valorParcela | currency: 'BRL' }}</span
        >
      </div>
    </div>
    <div class="info-block">
      <span class="icon calendario"></span>
      <div class="info">
        <span class="text">Data de Vencimento</span>
        <span class="value">{{ dataPrimeiroVencimento }}</span>
      </div>
    </div>
    <div class="info-block">
      <span class="icon cdc-loja"></span>
      <div class="info">
        <span class="text">Tabela</span>
        <span class="value">{{ proposta.tabela.descricao }}</span>
      </div>
    </div>
  </div>
</div>
